//
//
//
//
//
//
//
//
//
//
//
//
//

import Date from '@/components/date';
export default {
  name: 'schedule',
  components: {
    Date: Date
  },
  data: function data() {
    return {};
  },
  props: {
    // 日程列表
    includeSchedule: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    dateChange: function dateChange(date) {
      this.$emit('dateChange', date);
    }
  }
};